import { computeTotalDiscountAmount } from '@fhs/cart/src/state/cart-store/loyalty-helpers';
import { ITotals } from 'pages/cart/your-cart/totals/types';
import { OrderStatus, useOrderContext } from 'state/order';
import { useFlag } from 'utils/launchdarkly';
import { isDelivery } from 'utils/service-mode';

import { usePickupTips } from './use-pickup-tips';

export const useTotalTipCalculations = ({ serverOrder, serviceMode }: ITotals) => {
  const loading = !serverOrder || serverOrder.status === OrderStatus.PRICE_REQUESTED;
  const hideTipAmount = useFlag('hide-tip-amount-checkout');
  const isDeliveryOrder = isDelivery(serviceMode);
  const orderContext = useOrderContext();
  const { pickUpTipsCents } = usePickupTips(serviceMode);

  const { cart, delivery } = serverOrder || {};
  const deliveryFee = delivery ? delivery.feeCents : null;
  const deliveryFeeDiscount = delivery ? delivery.feeDiscountCents : null;
  const allDiscounts = cart?.discounts || [];

  const totalDiscountAmount = computeTotalDiscountAmount(allDiscounts);

  // delivery.tipCents is null until the user advances to PAYMENT_REQUESTED
  // at the same time, totalCents increases by the tip amount
  // we needed to do this to render the correct grand total/tip as user advances
  const serverOrderTip = Number(delivery?.tipCents || 0);

  const { subTotalCents, taxCents } = cart || {};

  const pickUpTips = !isDeliveryOrder && Boolean(pickUpTipsCents) ? pickUpTipsCents : 0;
  const deliveryTipAmount = isDeliveryOrder && !hideTipAmount ? orderContext.tipAmount : 0;

  const totalWithTips =
    (cart?.totalCents ?? 0) - Number(serverOrderTip) + deliveryTipAmount + pickUpTips;

  return {
    hideTipAmount,
    subTotalCents,
    taxCents,
    rewardDiscountAmount: 0,
    serverOrderTip,
    serverOrderPickUpTips: serverOrder?.cart.pickUpTipsCents || 0,
    additionalDiscountAmount: totalDiscountAmount,
    deliveryFee,
    deliveryFeeDiscount,
    loading,
    isDeliveryOrder,
    cart,
    delivery,
    totalWithTips,
  };
};
